// Swift's `String <`: Unicode scalar order of the canonically equivalent (NFC) strings. JS `<` compares UTF-16
// units, which differs only when a supplementary character meets U+E000–U+FFFF, and never for ASCII ids.

const ascii = /^[\x00-\x7f]*$/;

export function swiftCompare(a: string, b: string): number {
  if (ascii.test(a) && ascii.test(b)) return a < b ? -1 : a > b ? 1 : 0;
  const x = [...a.normalize('NFC')], y = [...b.normalize('NFC')];
  for (let i = 0; i < Math.min(x.length, y.length); i++) {
    const d = x[i].codePointAt(0)! - y[i].codePointAt(0)!;
    if (d !== 0) return d;
  }
  return x.length - y.length;
}

/** `localizedStandardCompare`: Finder's order (case-insensitive, numbers by value). Ties keep their order. */
export const standardCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
export const standardCompare = (a: string, b: string) => standardCollator.compare(a, b);
